import { Text } from '@epam/promo';
import './styles.scss';

interface Props {
  keywords: string[];
}

export const ProjectKeywords = (props: Props) => (
  <div className="project-detail-left__keywords">
    <Text
      fontSize={'14'}
      lineHeight={'24'}
      font={'museo-sans'}
      cx="project-detail-left__keywords-header"
    >
      Keywords:
    </Text>
    <Text
      fontSize={'14'}
      lineHeight={'24'}
      font={'museo-sans'}
      cx="project-detail-left__keywords-content"
    >
      {props.keywords.join(',   ')}
    </Text>
  </div>
);
